module.exports = __webpack_public_path__ + "media/spa/alert_icon-1f6151eb.svg";